<template>
    <v-container v-if="!hasRole" fluid>
        <div class="text-h6">
            You do not have any permissions configured for your account at present in the system. Please contact the
            relevant Admins to get some.
        </div>
        <div>
            If you believe you should already have been given permissions, please click
            <v-btn color="warning" @click="refreshUser" small>this button</v-btn> to refresh your user permissions.
        </div>
    </v-container>
    <Dashboard v-else />
</template>
<script>
import { mapState, mapActions } from 'vuex'
import api from '@/api'
import Dashboard from './dashboard/Dashboard.vue'
export default {
    name: 'HomePage',
    components: { Dashboard },
    data: () => ({
        drawer: null,
    }),
    computed: {
        ...mapState(['user']),
        hasRole() {
            return !!this.user.role
        },
    },
    methods: {
        ...mapActions(['checkUser']),
        async refreshUser() {
            await api.refreshPermissions()
            this.checkUser()
        },
    },
}
</script>
